import { ChangeDetectionStrategy, Component, ElementRef, inject, Input, OnChanges, OnInit, Renderer2 } from '@angular/core';
import { Category, ICategoryDataV3 } from '@df/catalog/category/category';
import { KlevuSearch } from '@df/module-klevu-search/klevu-interfaces';
import { KlevuSearchService } from '@df/module-klevu-search/klevu-search.service';
import { KlevuTrackService } from '@df/module-klevu-search/klevu-track.service';
import { UiComponent } from '@df/ui/ui.component';

declare module '@df/module-klevu-search/klevu-interfaces' {
    export namespace KlevuSearch {
        interface IBanner {
            mobileBannerImageUrl?: string;
        }
    }
}
@Component({
    selector: 'search-banner',
    templateUrl: './search-banner.html',
    styleUrls: ['./search-banner.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class SearchBannerComponent extends UiComponent implements OnInit, OnChanges {
    @Input()
    term?: string;

    // for now no support for position
    // @Input()
    // position?: 'top' | 'bottom';

    @Input()
    context?: 'preview' | 'searchPage' | 'category';

    @Input()
    category?: Category<ICategoryDataV3>;

    protected currentBanner?: KlevuSearch.IBanner;
    private banners?: KlevuSearch.IBanner[];
    private searchService = inject(KlevuSearchService);
    private klevuTrackService = inject(KlevuTrackService);
    private renderer2 = inject(Renderer2);
    private elementRef = inject(ElementRef);

    override ngOnInit(): void {
        super.ngOnInit();
        this.searchService.loadKlevuBanners().then(() => {
            this.banners = this.searchService.getEligibleBanners();
            this.updateBanner();
        });
    }

    override ngOnChanges(changes: any): void {
        super.ngOnChanges(changes);
        if (this.banners?.length) {
            this.updateBanner();
        }
    }

    private updateBanner(): void {
        const term = this.term?.toLowerCase();
        this.currentBanner = this.banners?.find(banner => {
            const validContext =
                (this.context === 'preview' && banner.showOnQuickSearch) ||
                (this.context === 'searchPage' && banner.showOnLandingPage) ||
                (this.context === 'category' && banner.showOnCategoryPage);

            if (!validContext) {
                return false;
            }
            const validTerm =
                !banner.showForTerms?.length ||
                (this.context === 'category' && this.category
                    ? banner.showForTerms?.includes(this.searchService.getCategoryPath(this.category!)?.toLowerCase())
                    : term && banner.showForTerms?.includes(term));

            if (!validTerm) {
                return false;
            }
            const now = new Date();
            return (!banner.startDate || new Date(banner.startDate) <= now) && (!banner.endDate || new Date(banner.endDate) >= now);
        });

        this.currentBanner
            ? this.renderer2.addClass(this.elementRef.nativeElement, '_visible')
            : this.renderer2.removeClass(this.elementRef.nativeElement, '_visible');
        this.detectChanges();
    }

    get currentBannerImg(): string | undefined {
        if (this.client.isM || this.client.isS) {
            return this.currentBanner?.mobileBannerImageUrl || this.currentBanner?.bannerImg;
        } else {
            return this.currentBanner?.bannerImg;
        }
    }

    protected trackClick() {
        if (this.currentBanner && this.term) {
            this.klevuTrackService.trackBanner(this.currentBanner, this.term);
        }
    }
}
